import CourseRoute from './CourseRoute';

export default {
  name: 'Courses',
  location: '/courses',
  component: CourseRoute,
};
